<p-confirmDialog #confirmDialog header="Confirmação" position="top" [style]="{minWidth: '30vw'}" appendTo="body" [transitionOptions]="transitionOptions">
  <ng-template pTemplate="footer">
    <app-button [label]="rejectLabel" [variant]="buttonVariant.LINK" [color]="buttonColor.NEUTRAL_LIGHT" [callback]="callbackReject" [hasIcon]="false"></app-button>
    <app-button [icon]="primeIcon.CHECK" [label]="acceptLabel" [callback]="callbackAccept"></app-button>
  </ng-template>
</p-confirmDialog>